import React from "react";

const Svg = ({ size, color, strokeWidth, children }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

export const Sparkles = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>
    <path d="M20 3l.94 2.06L23 6l-2.06.94L20 9l-.94-2.06L17 6l2.06-.94z"/>
    <path d="M4 13l.94 2.06L7 16l-2.06.94L4 19l-.94-2.06L1 16l2.06-.94z"/>
  </Svg>
);

export const MailIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </Svg>
);

export const AlertTriangle = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="m21.73 18-8-14a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/>
    <path d="M12 9v4"/>
    <path d="M12 17h.01"/>
  </Svg>
);

export const CheckIcon = ({ size = 16, color = "currentColor", strokeWidth = 2 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M20 6 9 17l-5-5"/>
  </Svg>
);

export const XIcon = ({ size = 16, color = "currentColor", strokeWidth = 2 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M18 6 6 18"/>
    <path d="m6 6 12 12"/>
  </Svg>
);

export const StarIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8, filled = false }) => (
  <svg width={size} height={size} viewBox="0 0 24 24"
    fill={filled ? color : "none"} stroke={color} strokeWidth={strokeWidth}
    strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

export const ZapIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
  </Svg>
);

export const SettingsIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
    <circle cx="12" cy="12" r="3"/>
  </Svg>
);

export const LockIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </Svg>
);

export const UnlockIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
    <path d="M7 11V7a5 5 0 0 1 9.9-1"/>
  </Svg>
);

export const UserIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </Svg>
);

export const UsersIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </Svg>
);

export const BellIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/>
    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>
  </Svg>
);

export const PuzzleIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.802-.48-.968-.925a2.501 2.501 0 1 0-3.214 3.214c.446.166.855.497.925.968a.979.979 0 0 1-.276.837l-1.61 1.61a2.404 2.404 0 0 1-3.407 0l-1.568-1.568a1.026 1.026 0 0 0-.877-.29c-.493.074-.84.504-1.02.968a2.5 2.5 0 1 1-3.237-3.237c.464-.18.894-.527.967-1.02a1.026 1.026 0 0 0-.289-.877l-1.568-1.568A2.402 2.402 0 0 1 1.998 12c0-.617.236-1.234.706-1.704L4.23 8.77c.24-.24.581-.353.917-.303.515.077.877.528 1.073 1.01a2.5 2.5 0 1 0 3.259-3.259c-.482-.196-.933-.558-1.01-1.073-.05-.336.062-.676.303-.917l1.525-1.525A2.402 2.402 0 0 1 12 2c.617 0 1.234.236 1.704.706l1.568 1.568c.23.23.556.338.877.29.493-.074.84-.504 1.02-.968a2.5 2.5 0 1 1 3.237 3.237c-.464.18-.894.527-.967 1.02z"/>
  </Svg>
);

export const UploadIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="17 8 12 3 7 8"/>
    <line x1="12" y1="3" x2="12" y2="15"/>
  </Svg>
);

export const SunIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <circle cx="12" cy="12" r="4"/>
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>
  </Svg>
);

export const MoonIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/>
  </Svg>
);

export const PencilIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/>
  </Svg>
);

export const LightbulbIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/>
    <path d="M9 18h6"/>
    <path d="M10 22h4"/>
  </Svg>
);

export const MicIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z"/>
    <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
    <line x1="12" y1="19" x2="12" y2="23"/>
    <line x1="8" y1="23" x2="16" y2="23"/>
  </Svg>
);

export const PenLineIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M12 20h9"/>
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
  </Svg>
);

export const PlayIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <polygon points="5 3 19 12 5 21 5 3"/>
  </Svg>
);

export const PauseIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <rect x="6" y="4" width="4" height="16"/>
    <rect x="14" y="4" width="4" height="16"/>
  </Svg>
);

export const InfoIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <circle cx="12" cy="12" r="10"/>
    <path d="M12 16v-4"/>
    <path d="M12 8h.01"/>
  </Svg>
);

export const UndoIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M3 7v6h6"/>
    <path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13"/>
  </Svg>
);

export const RedoIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M21 7v6h-6"/>
    <path d="M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7"/>
  </Svg>
);

export const AwardIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <circle cx="12" cy="8" r="6"/>
    <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>
  </Svg>
);

export const LogInIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
    <polyline points="10 17 15 12 10 7"/>
    <line x1="15" y1="12" x2="3" y2="12"/>
  </Svg>
);

export const GraduationCapIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
    <path d="M6 12v5c3 3 9 3 12 0v-5"/>
  </Svg>
);

export const BriefcaseIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <rect width="20" height="14" x="2" y="7" rx="2"/>
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
  </Svg>
);

export const FolderIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
  </Svg>
);

export const GlobeIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <circle cx="12" cy="12" r="10"/>
    <path d="M2 12h20"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </Svg>
);

export const EyeIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/>
    <circle cx="12" cy="12" r="3"/>
  </Svg>
);

export const EyeOffIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/>
    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/>
    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/>
    <line x1="2" y1="2" x2="22" y2="22"/>
  </Svg>
);

export const ArrowLeftIcon = ({ size = 16, color = "currentColor", strokeWidth = 2 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M19 12H5"/>
    <path d="m12 19-7-7 7-7"/>
  </Svg>
);

export const ArrowRightIcon = ({ size = 16, color = "currentColor", strokeWidth = 2 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M5 12h14"/>
    <path d="m12 5 7 7-7 7"/>
  </Svg>
);

export const LoaderIcon = ({ size = 16, color = "currentColor", strokeWidth = 2 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
  </Svg>
);

export const PlusIcon = ({ size = 16, color = "currentColor", strokeWidth = 2 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M12 5v14"/>
    <path d="M5 12h14"/>
  </Svg>
);

export const TrashIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M3 6h18"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/>
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
    <line x1="10" y1="11" x2="10" y2="17"/>
    <line x1="14" y1="11" x2="14" y2="17"/>
  </Svg>
);

export const BarChartIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <line x1="12" y1="20" x2="12" y2="10"/>
    <line x1="18" y1="20" x2="18" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="16"/>
  </Svg>
);

export const TargetIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <circle cx="12" cy="12" r="10"/>
    <circle cx="12" cy="12" r="6"/>
    <circle cx="12" cy="12" r="2"/>
  </Svg>
);

export const FileTextIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="8" y1="13" x2="16" y2="13"/>
    <line x1="8" y1="17" x2="16" y2="17"/>
  </Svg>
);

export const BanIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <circle cx="12" cy="12" r="10"/>
    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
  </Svg>
);

export const DownloadIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </Svg>
);

export const SearchIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <circle cx="11" cy="11" r="8"/>
    <path d="m21 21-4.3-4.3"/>
  </Svg>
);

export const RobotIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <rect x="3" y="9" width="18" height="11" rx="2"/>
    <circle cx="8.5" cy="14.5" r="1.3" fill={color} stroke="none"/>
    <circle cx="15.5" cy="14.5" r="1.3" fill={color} stroke="none"/>
    <path d="M12 9V5"/>
    <circle cx="12" cy="3.5" r="1.5"/>
    <path d="M7 9V7a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"/>
  </Svg>
);

export const MessageSquareIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </Svg>
);

export const CameraIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
    <circle cx="12" cy="13" r="4"/>
  </Svg>
);

export const ClipboardIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
  </Svg>
);

export const FlameIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>
  </Svg>
);

export const LaptopIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <rect x="2" y="3" width="20" height="14" rx="2"/>
    <line x1="8" y1="21" x2="16" y2="21"/>
    <line x1="12" y1="17" x2="12" y2="21"/>
  </Svg>
);

export const MegaphoneIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="m3 11 18-5v12L3 14v-3z"/>
    <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/>
  </Svg>
);

export const LandmarkIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <line x1="3" y1="22" x2="21" y2="22"/>
    <line x1="6" y1="18" x2="6" y2="11"/>
    <line x1="10" y1="18" x2="10" y2="11"/>
    <line x1="14" y1="18" x2="14" y2="11"/>
    <line x1="18" y1="18" x2="18" y2="11"/>
    <polygon points="12 2 20 7 4 7"/>
  </Svg>
);

export const TrendingUpIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
    <polyline points="17 6 23 6 23 12"/>
  </Svg>
);

export const WrenchIcon = ({ size = 16, color = "currentColor", strokeWidth = 1.8 }) => (
  <Svg size={size} color={color} strokeWidth={strokeWidth}>
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
  </Svg>
);
